import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import { StaffFrame } from "./DashboardShared";

const C = { green:"#006B3C", greenLt:"#E8F5EE", yellow:"#FFC300", grayBd:"#E0E0E0", text:"#1A1A1A", textSub:"#666" };

const CLASS_COLORS = {
  ECONOMIQUE: { bg:"#E3F2FD", color:"#1565C0" },
  PREMIERE:   { bg:"#F3E5F5", color:"#6A1B9A" },
  VIP:        { bg:"#FFF3E0", color:"#E65100" },
};

export default function AdminSchedules() {
  const [schedules, setSchedules] = useState([]);
  const [stations,  setStations]  = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [showForm,  setShowForm]  = useState(false);
  const [form, setForm] = useState({
    trainNumber:"", travelClass:"ECONOMIQUE", departureId:"", arrivalId:"",
    departureDateTime:"", arrivalDateTime:"", price:"", seats:""
  });

  const loadData = async () => {
    setLoading(true);
    try {
      const [sch, sta] = await Promise.all([
        api.get("/api/trips"),
        api.get("/cities"),
      ]);
      setSchedules(sch.data);
      setStations(sta.data);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { loadData(); }, []);

  const handleCreate = async () => {
    try {
      await api.post("/api/trips", form);
      setShowForm(false);
      setForm({ trainNumber:"", travelClass:"ECONOMIQUE", departureId:"", arrivalId:"", departureDateTime:"", arrivalDateTime:"", price:"", seats:"" });
      loadData();
      alert("Voyage créé avec succès");
    } catch (e) {
      alert(e.response?.data?.message || "Erreur création");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce voyage ?")) return;
    try {
      await api.delete(`/api/trips/${id}`);
      loadData();
    } catch { alert("Erreur suppression"); }
  };

  return (
    <StaffFrame>
      <div style={{ padding:24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div>
            <h1 style={{ margin:0, fontSize:22, fontWeight:700 }}>Gestion des horaires</h1>
            <p style={{ margin:0, color:C.textSub, fontSize:13 }}>Voyages disponibles sur la ligne Transgabonais</p>
          </div>
          <button onClick={() => setShowForm(!showForm)}
            style={{ background:C.green, color:"#fff", border:"none", borderRadius:10, padding:"10px 20px", fontWeight:700, cursor:"pointer" }}>
            + Nouveau voyage
          </button>
        </div>

        {/* ── Formulaire ── */}
        {showForm && (
          <div style={{ background:"#fff", borderRadius:14, padding:24, marginBottom:24, border:`1.5px solid ${C.grayBd}`, boxShadow:"0 2px 12px rgba(0,0,0,0.06)" }}>
            <h3 style={{ margin:"0 0 16px" }}>Créer un voyage</h3>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
              <div>
                <label style={s.label}>N° Train</label>
                <input style={s.input} placeholder="TR-101" value={form.trainNumber}
                  onChange={e => setForm({...form, trainNumber:e.target.value})} />
              </div>
              <div>
                <label style={s.label}>Classe</label>
                <select style={s.input} value={form.travelClass}
                  onChange={e => setForm({...form, travelClass:e.target.value})}>
                  <option value="ECONOMIQUE">Économique</option>
                  <option value="PREMIERE">1ère Classe</option>
                  <option value="VIP">VIP</option>
                </select>
              </div>
              <div>
                <label style={s.label}>Gare de départ</label>
                <select style={s.input} value={form.departureId}
                  onChange={e => setForm({...form, departureId:e.target.value})}>
                  <option value="">Choisir...</option>
                  {stations.map(st => <option key={st.id} value={st.id}>{st.name}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Gare d'arrivée</label>
                <select style={s.input} value={form.arrivalId}
                  onChange={e => setForm({...form, arrivalId:e.target.value})}>
                  <option value="">Choisir...</option>
                  {stations.map(st => <option key={st.id} value={st.id}>{st.name}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Départ (date + heure)</label>
                <input style={s.input} type="datetime-local" value={form.departureDateTime}
                  onChange={e => setForm({...form, departureDateTime:e.target.value})} />
              </div>
              <div>
                <label style={s.label}>Arrivée (date + heure)</label>
                <input style={s.input} type="datetime-local" value={form.arrivalDateTime}
                  onChange={e => setForm({...form, arrivalDateTime:e.target.value})} />
              </div>
              <div>
                <label style={s.label}>Prix (FCFA)</label>
                <input style={s.input} type="number" placeholder="12500" value={form.price}
                  onChange={e => setForm({...form, price:e.target.value})} />
              </div>
              <div>
                <label style={s.label}>Nombre de places</label>
                <input style={s.input} type="number" placeholder="60" value={form.seats}
                  onChange={e => setForm({...form, seats:e.target.value})} />
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:16 }}>
              <button onClick={handleCreate}
                style={{ background:C.green, color:"#fff", border:"none", borderRadius:8, padding:"10px 24px", fontWeight:700, cursor:"pointer" }}>
                Créer
              </button>
              <button onClick={() => setShowForm(false)}
                style={{ background:"#fff", color:C.text, border:`1.5px solid ${C.grayBd}`, borderRadius:8, padding:"10px 20px", cursor:"pointer" }}>
                Annuler
              </button>
            </div>
          </div>
        )}

        {/* ── Table ── */}
        {loading ? (
          <div style={{ textAlign:"center", padding:60, color:C.textSub }}>Chargement...</div>
        ) : (
          <div style={{ background:"#fff", borderRadius:14, overflow:"hidden", border:`1px solid ${C.grayBd}` }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:C.greenLt }}>
                  {["Train","Trajet","Date départ","Arrivée","Classe","Prix","Places","Rés.","Actions"].map(h => (
                    <th key={h} style={{ padding:"12px 14px", textAlign:"left", fontSize:12, fontWeight:700, color:C.textSub, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {schedules.map((t, i) => {
                  const cc = CLASS_COLORS[t.travelClass] || CLASS_COLORS.ECONOMIQUE;
                  return (
                    <tr key={t.id} style={{ borderTop:`1px solid ${C.grayBd}`, background: i%2===0?"#fff":"#FAFAFA" }}>
                      <td style={s.td}><strong>{t.trainNumber}</strong></td>
                      <td style={s.td}>{t.departure} → {t.arrival}</td>
                      <td style={s.td}>{t.date} {t.departureTime}</td>
                      <td style={s.td}>{t.arrivalTime || "-"}</td>
                      <td style={s.td}>
                        <span style={{ background:cc.bg, color:cc.color, padding:"2px 8px", borderRadius:20, fontSize:11, fontWeight:600 }}>
                          {t.travelClass}
                        </span>
                      </td>
                      <td style={s.td}>{Number(t.price).toLocaleString("fr-FR")} FCFA</td>
                      <td style={s.td}>{t.seats}/{t.totalSeats}</td>
                      <td style={s.td}>{t.bookingsCount || 0}</td>
                      <td style={s.td}>
                        <button onClick={() => handleDelete(t.id)}
                          style={{ background:"#FEE2E2", color:"#DC2626", border:"none", borderRadius:6, padding:"4px 10px", fontSize:12, cursor:"pointer" }}>
                          Supprimer
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {schedules.length === 0 && (
              <div style={{ textAlign:"center", padding:40, color:C.textSub }}>Aucun voyage programmé.</div>
            )}
          </div>
        )}
      </div>
    </StaffFrame>
  );
}

const s = {
  label: { display:"block", fontSize:12, fontWeight:600, color:"#666", marginBottom:4 },
  input: { width:"100%", border:"1.5px solid #E0E0E0", borderRadius:8, padding:"9px 12px", fontSize:13, outline:"none", boxSizing:"border-box" },
  td:    { padding:"12px 14px", fontSize:13 },
};
